import { requestJson } from "./apiClient";
import {
  createSponsorshipCampaign,
  createSponsorshipInventorySlot,
  createSponsorshipPlacement,
  listSponsorshipCampaigns,
  listSponsorshipInventorySlots,
  listSponsorshipPlacements,
  patchSponsorshipInventorySlotStatus,
  patchSponsorshipPlacementStatus,
  previewSponsorshipPlacement,
} from "./adminClientViewSponsorshipApi";

const AUTOMAP_BASE = "/api/partner/automap/sponsorship";
const AUTH_OPTIONS = { skipAuthRedirect: true };

export function createAdminClientViewSponsorshipApi(clientViewId) {
  return {
    listInventorySlots: () => listSponsorshipInventorySlots(clientViewId),
    createInventorySlot: (payload) => createSponsorshipInventorySlot(clientViewId, payload),
    patchInventorySlotStatus: (slotId, isActive) =>
      patchSponsorshipInventorySlotStatus(clientViewId, slotId, isActive),
    listPlacements: (query) => listSponsorshipPlacements(clientViewId, query),
    createPlacement: (payload) => createSponsorshipPlacement(clientViewId, payload),
    patchPlacementStatus: (placementId, status) =>
      patchSponsorshipPlacementStatus(clientViewId, placementId, status),
    previewPlacement: (placementId) => previewSponsorshipPlacement(clientViewId, placementId),
    listCampaigns: () => listSponsorshipCampaigns(clientViewId),
    createCampaign: (payload) => createSponsorshipCampaign(clientViewId, payload),
    listPartners: async () => ({ partners: [] }),
  };
}

export function createAutomapPartnerSponsorshipApi() {
  return {
    listInventorySlots: () => requestJson(`${AUTOMAP_BASE}/inventory`, AUTH_OPTIONS),
    createInventorySlot: (payload) =>
      requestJson(`${AUTOMAP_BASE}/inventory`, { ...AUTH_OPTIONS, method: "POST", body: payload }),
    patchInventorySlotStatus: (slotId, isActive) =>
      requestJson(`${AUTOMAP_BASE}/inventory/${encodeURIComponent(slotId)}/status`, {
        ...AUTH_OPTIONS,
        method: "PATCH",
        body: { isActive },
      }),
    listPlacements: (query = {}) => {
      const params = new URLSearchParams(query).toString();
      const suffix = params ? `?${params}` : "";
      return requestJson(`${AUTOMAP_BASE}/placements${suffix}`, AUTH_OPTIONS);
    },
    createPlacement: (payload) =>
      requestJson(`${AUTOMAP_BASE}/placements`, { ...AUTH_OPTIONS, method: "POST", body: payload }),
    patchPlacementStatus: (placementId, status) =>
      requestJson(`${AUTOMAP_BASE}/placements/${encodeURIComponent(placementId)}/status`, {
        ...AUTH_OPTIONS,
        method: "PATCH",
        body: { status },
      }),
    previewPlacement: (placementId) =>
      requestJson(`${AUTOMAP_BASE}/placements/${encodeURIComponent(placementId)}/preview`, {
        ...AUTH_OPTIONS,
        method: "POST",
      }),
    listCampaigns: () => requestJson(`${AUTOMAP_BASE}/campaigns`, AUTH_OPTIONS),
    createCampaign: (payload) =>
      requestJson(`${AUTOMAP_BASE}/campaigns`, { ...AUTH_OPTIONS, method: "POST", body: payload }),
    listPartners: () => requestJson(`${AUTOMAP_BASE}/partners`, AUTH_OPTIONS),
  };
}

export function fetchAutomapSponsorshipSettings() {
  return requestJson(`${AUTOMAP_BASE}/settings`, AUTH_OPTIONS);
}

export function patchAutomapSponsorshipSettings(enabled) {
  return requestJson(`${AUTOMAP_BASE}/settings`, {
    ...AUTH_OPTIONS,
    method: "PATCH",
    body: { enabled },
  });
}
